<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="shopuserinfo" :rules="rules" ref="shopuserrule" label-width="120px" class="">
			<el-row>
				<!-- <el-col :span="8">
					<el-form-item label="所属商家" prop="service_business_id">
					    <el-select style="width: 100%;" v-model="shopuserinfo.service_business_id" placeholder="请选择商家">
							<el-option v-for="item in businesses" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					    </el-select>
					</el-form-item>
				</el-col> -->
				<el-col :span="8">
					<el-form-item label="所属档口" prop="service_stall_id">
					    <el-select style="width: 100%;" v-model="shopuserinfo.service_stall_id" placeholder="请选择商家">
							<el-option v-for="item in stalls" :key="item.stall_id" :label="item.stall_name" :value="item.stall_id"> </el-option>
					    </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="用户名" prop="username">
						<el-input clearable v-model="shopuserinfo.username" maxlength="20"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="真实姓名" prop="realname">
						<el-input clearable v-model="shopuserinfo.realname" maxlength="20"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="电话" prop="telphone">
						<el-input clearable v-model="shopuserinfo.telphone" maxlength="20"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="过期时间" prop="expirationdate">
						<el-date-picker style="width: 100%;" v-model="shopuserinfo.expirationdate" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveShopUsers">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { getShopUserDetail,addNewShopUser, editShopUser } from '/static/apiUrl.js'
	export default {
		name : 'ShopUserDetail',
		data() {
			return {
				editok : false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},				
				shopuserinfo : {
					"id": "",
					"username": "",
					"realname": "",
					"telphone": "",
					"expirationdate": "",
					"state": "",
					"service_stall_id": "",
				},			
				rules:{
					username: [
						{ required: true, message: '请输入用户名', trigger: 'blur' }
					],
					realname: [
						{ required: true, message: '请输入真实姓名', trigger: 'blur' }
					],
					telphone: [
						{ required: true, message: '请输入电话', trigger: 'blur' }
					],
					expirationdate: [
						{ required: true, message: '请输入过期时间', trigger: 'blur' }
					],
					service_stall_id: [
						{ required: true, message: '请选择所属档口', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			select_id : {
				type: String,
				required: false
			},
			stalls : {
				type : Array,
				required : true
			}
		},
		watch: {
			select_id: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.shopuserDetail(newVal)
				}
			},
		},
		methods: {
			clearData(){
				this.shopuserinfo = {
					"id": "",
					"username": "",
					"realname": "",
					"telphone": "",
					"expirationdate": "",
					"state": "",
					"service_stall_id": "",
				}
				this.editok = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			shopuserDetail(id){
				if(id !== undefined && id !== null && id != ''){
					getShopUserDetail({id : id}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.shopuserinfo = res.data
						}
					})
				}
			},
			saveShopUsers(){
				this.$refs["shopuserrule"].validate((valid) => {
					if (valid) {
						if(this.shopuserinfo.id != null && this.shopuserinfo.id != ''){  //编辑
							editShopUser(this.shopuserinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改商家用户信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg,true)
								}
							})
						}else{ //新增
							addNewShopUser(this.shopuserinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加商家用户信息成功")
								}else{
									this.$emit("needRefrash",false,true)
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>